// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1sW-G","footer":"ModalCreateQualiphyProcedure_footer__1UnBP","additionData":"ModalCreateQualiphyProcedure_additionData__CDS1Q"};